export const SET_INDUSIND_ZINGER_CARDS_FAQ = 'indusindZingerCard/SET_INDUSIND_ZINGER_CARDS_FAQ';
export const SET_INDUSIND_KUBER_CARDS_FAQ = 'indusindKuberCard/SET_INDUSIND_KUBER_CARDS_FAQ';
export const DEFAULT_ACTION = '/IndusindFaqs/DEFAULT_ACTION';




// WEBPACK FOOTER //
// client/containers/IndusindZingerCardsFaqs/constants.js